<template>
    <ForgotPassword></ForgotPassword>
</template>

<script>
    import ForgotPassword from "../components/ForgotPassword";

    export default {
        name: "forgotpassword",
        components: {
            ForgotPassword,
        }
    };
</script>